/* eslint-disable */
import voucher from './voucher';

import { combineReducers, } from 'redux';

export default combineReducers({
  voucher,
})